import { z } from 'zod';

const MAX_MESSAGE_LENGTH = 2_000;
const MAX_STACK_LENGTH = 8_000;

export const ClientErrorReportSchema = z.object({
	message: z.string().max(MAX_MESSAGE_LENGTH),
	stack: z.string().max(MAX_STACK_LENGTH).nullable(),
	path: z.string().max(MAX_MESSAGE_LENGTH),
	routeId: z.string().max(MAX_MESSAGE_LENGTH).nullable()
});

export type ClientErrorReport = Readonly<z.infer<typeof ClientErrorReportSchema>>;

export function clientErrorReport(
	error: unknown,
	page: URL,
	routeId: string | null
): ClientErrorReport {
	return {
		message: messageOf(error).slice(0, MAX_MESSAGE_LENGTH),
		stack: error instanceof Error && error.stack ? error.stack.slice(0, MAX_STACK_LENGTH) : null,
		path: `${page.pathname}${page.search}`.slice(0, MAX_MESSAGE_LENGTH),
		routeId: routeId?.slice(0, MAX_MESSAGE_LENGTH) ?? null
	};
}

function messageOf(error: unknown): string {
	return error instanceof Error ? error.message : String(error);
}
